import { bindable, customElement } from 'aurelia';
import template from './media-fold-modal.html';
import { getMediaPreviewUrl } from '../services/api.service';
import type { MediaItem } from '../services/api.types';

@customElement({ name: 'media-fold-modal', template })
export class MediaFoldModal {
  @bindable public items: MediaItem[] = [];
  @bindable public confirmed!: (representativeId: string) => void;
  @bindable public closed!: () => void;
  @bindable public management = false;
  @bindable public busy = false;

  public representativeId = '';

  public get titleKey(): string {
    return this.management ? 'gallery.folding.manageTitle' : 'gallery.folding.title';
  }

  public get promptKey(): string {
    return this.management
      ? 'gallery.folding.chooseExistingRepresentative'
      : 'gallery.folding.chooseRepresentative';
  }

  public get confirmKey(): string {
    return this.management
      ? 'gallery.folding.changeRepresentative'
      : 'gallery.folding.confirm';
  }

  public binding(): void {
    this.representativeId = this.items[0]?.id ?? '';
  }

  public itemsChanged(newItems: MediaItem[]): void {
    if (!newItems.some(item => item.id === this.representativeId))
      this.representativeId = newItems[0]?.id ?? '';
  }

  public previewUrl(item: MediaItem): string {
    return getMediaPreviewUrl(item.id, item.lastUpdatedAt || item.uploadedAt);
  }

  public selectRepresentative(item: MediaItem): void {
    this.representativeId = item.id;
  }

  public confirm(): void {
    if (!this.representativeId || this.busy) return;
    this.confirmed(this.representativeId);
  }

  public close(): void {
    this.closed();
  }
}
